import { ETICHETTE } from "@/data/simulatorCopy";

export const ResultProfile = ({ result }) => {
  const { archetype, narrative } = result;
  return (
    <div>
      <h3 className="font-extrabold tracking-[-0.03em] leading-tight text-2xl sm:text-3xl text-white" data-testid="sim-headline">
        {archetype.titolo}
      </h3>
      <p className="mt-4 text-sm sm:text-base text-white/90" data-testid="sim-archetype">
        {ETICHETTE.archetipo}: <strong className="text-cyan font-bold" data-testid="sim-archetype-name">{archetype.nome}</strong>
        <span className="text-titanium"> — {archetype.descrizione}</span>
      </p>
      <p className="mt-4 text-sm sm:text-[15px] leading-relaxed text-titanium" data-testid="sim-analysis">
        {narrative}
      </p>
    </div>
  );
};
